/*eslint no-unused-vars: "off"*/
import moment from 'moment';
import React from 'react';
import smile_icon from "../../../../Assets/images/smile.png";
import neutral_icon from "../../../../Assets/images/confused.png";
import sad_icon from "../../../../Assets/images/sad.png";
import { formatToCurrency } from '../../../../Tools/formatToCurrency';
import { convertFirstCharToUppercase } from '../../../../Tools/convertFirstLetterToUppercase';
import { aboutUsData } from "../../../../Assets/data/aboutUsList";

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every other week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
}

// Mapping property types
const PROPERTY_TYPE_MAPPING = {
  townhomes:"Town Homes",
  detached:"Detached homes",
  condo:"Condominiums",
  apartment:"Apartments",
}

const formattedCouponList = (coupon_type_list) => {
  let list = coupon_type_list;

  coupon_type_list.forEach((element, index) => {
    switch (element)
    {
      case "perc_off_init_clean":
          list[index] = "% Off Initial Cleaning"
        break;
      case "dollar_off_services":
          list[index] = "Dollar Off For Services"
        break;
      case "perc_off_services":
          list[index] = "% Off For Services"
        break;
      case "free_gift":
          list[index] = "Free gift"
        break;
    }
  });
  
  return list.join(',');
}

class DataTable {

  //Report
  CustomerStatementReport = (self) => {
    const csrColumns = [
      {
        title: 'Date',
        dataIndex: 'invoice_date',
        key: 'date',
        className: 'tdate',
        render: (text, record) => (<React.Fragment><span className="type ellipse">{text}</span></React.Fragment>)
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        className: 'tprice',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Invoice #',
        dataIndex: 'invoice_id',
        key: 'invoice_id',
        sorter: false,
        showSorterTooltip: false,
        className: 'tprice',
        render: (text, record) => (<span className="type ellipse">{record.invoice_id}</span>)
      },
      {
        title: 'Due Date',
        dataIndex: 'due_date',
        key: 'due_date',
        sorter: false,
        showSorterTooltip: false,
        className: 'tdate lfbdr',
        render: (text, record) => (<span className="type ellipse">{record.due_date}</span>)
      },
      {
        title: 'Invoice Amount',
        dataIndex: 'total_with_tax',
        key: 'total_with_tax',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">${text ? formatToCurrency(text) : '0.00'}</span>)
      },
      {
        title: 'Paid',
        dataIndex: 'paid',
        key: 'paid',
        className: 'tprice lfbdr ',
        render: (text, record ) => (<span className="type ellipse">${text ? formatToCurrency(text) : '0.00'}</span>)
      },
      {
        title: 'Method',
        dataIndex: 'method',
        key: 'method',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.method}</span>)
      },
      {
        title: 'Balance',
        dataIndex: 'balance_due',
        key: 'balance_due',
        className: 'tprice',
        render: (text, record) => (<span className="type ellipse">${text ? text : '0.00'}</span>)
      }

    ]
    return csrColumns;
  }

  DailyLogReport = (self) => {
    const dlrColumns = [
      {
        title: 'Franchise',
        dataIndex: 'franchise',
        key: 'franchise',
        className: 'tname',
        render: (text, record) => (<React.Fragment><span className="type ellipse">{text}</span></React.Fragment>)
      },
      {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        showSorterTooltip: false,
        className: 'tdate',
        render: (text,record) => (<span className="type ellipse">{moment(record.created_at).format('MMM D, YYYY')}</span>)
      },
      {
        title: 'Customer Rep',
        dataIndex: 'initiated_by__first_name',
        key: 'customer_rep',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.customer_rep}</span>)
      },
      {
        title: 'Account',
        dataIndex: 'user__last_name',
        key: 'account',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.account}</span>)
      },
      {
        title: 'Action Performed',
        dataIndex: 'type',
        key: 'action_performed',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.action_performed}</span>)
      }

    ]

    if(self.state.franchiseFilters.search && !self.state.franchiseFilters.franchise_id){
      dlrColumns.splice(2, 1)
    }

    return dlrColumns;
  }

  DailyLogReportDetail = (self) => {
    const dlrDetailColumns = [
      {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        className: 'tdate',
        render: (text,record) => (<span className="type ellipse">{moment(record.created_at).format('MMM D, YYYY')}</span>)
      },
      {
        title: 'Customer Rep',
        dataIndex: 'customer_rep',
        key: 'customer_rep',
        sorter: false,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.customer_rep}</span>)
      },
      {
        title: 'Account',
        dataIndex: 'account',
        key: 'account',
        sorter: false,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.account}</span>)
      },
      {
        title: 'Action Performed',
        dataIndex: 'type',
        key: 'action_performed',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.action_performed}</span>)
      }

    ]
    return dlrDetailColumns;
  }

  InTerritoryRevenueReport = ( self ) => {
    const revenueReportColumns = [
      {
        title: 'Property Type',
        dataIndex: 'zipcode',
        key: 'zipcode',
        className: 'tname',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        sorter: false,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Started Service',
        dataIndex: 'started_service',
        key: 'started_service',
        sorter: false,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Active Customers',
        dataIndex: 'active_customers',
        key: 'active_customers',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Monthy Rev Avg. past 6 months',
        dataIndex: 'monthly_revenue_avg_six_months',
        key: 'monthly_revenue_avg_six_months',
        className: 'tname wrap',
        render: (text, record) => (<span className="type ellipse">${text? formatToCurrency(text) : '0.00'}</span>)
      },
      {
        title: 'YTD Revenue',
        dataIndex: 'ytd_revenue',
        key: 'ytd_revenue',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">${text ? formatToCurrency(text) : "0.00"}</span>)
      },
      {
        title: 'All time Revenue',
        dataIndex: 'all_time_revenue',
        key: 'all_time_revenue',
        className: 'taddress',
        render: (text, record) => (<span className="type ellipse">${text ? formatToCurrency(text) : '0.00'}</span>)
      },
      {
        title: 'Satisfaction',
        dataIndex: 'satisfaction',
        key: 'satisfation',
        className: 'tnumber',
        render: (text, record) => (<span className="type ellipse">{text ? text+'%' : '0%'}</span>)
      }
    ]
    return revenueReportColumns;
  }

  InTerritoryRevenueReportDetails = ( self ) => {
    const revenueReportDetailsColumns = [
      {
        title: 'Zipcode',
        dataIndex: 'zipcode',
        key: 'zipcode',
        className: 'tname',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        sorter: false,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Started Service',
        dataIndex: 'started_service',
        key: 'started_service',
        sorter: false,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Active Customers',
        dataIndex: 'active_customers',
        key: 'active_customers',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Monthy Rev Avg. past 6 months',
        dataIndex: 'monthly_revenue_avg_six_months',
        key: 'monthly_revenue_avg_six_months',
        className: 'tname wrap',
        render: (text, record) => (<span className="type ellipse">$ {text ? formatToCurrency(text) : '0.00'}</span>)
      },
      {
        title: 'YTD Revenue',
        dataIndex: 'ytd_revenue',
        key: 'ytd_revenue',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">$ {text ? formatToCurrency(text) : '0.00'}</span>)
      },
      {
        title: 'All time Revenue',
        dataIndex: 'all_time_revenue',
        key: 'all_time_revenue',
        className: 'taddress',
        render: (text, record) => (<span className="type ellipse">$ {text ? formatToCurrency(text) : '0.00'}</span>)
      },
      {
        title: 'Satisfaction',
        dataIndex: 'satisfaction',
        key: 'satisfaction',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">${text ? formatToCurrency(text) : "-"}</span>)
      }
    ]
    return revenueReportDetailsColumns;
  }

  CustomerComplaintsReport = ( self ) => {
    const customerComplaintColumns = [
      {
        title: 'Franchise',
        dataIndex: 'name',
        key: 'name',
        className: 'tname',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: '',
        dataIndex: '',
        key: 'view_breakdown',
        className: 'tname',
        render: (text, record) => (<React.Fragment><span className="type ellipse view-breakdown" onClick={() => {
          self.setState({
            reportdetails: true,
            loader: true,
            franchiseFilters: {
              ...self.state.franchiseFilters,
              id: record.id
            }
          })
          self.props.getCustomerComplaintsReportById({id: record.id, date_range: self.state.franchiseFilters.user__messages__created_at__date__range ? self.state.franchiseFilters.user__messages__created_at__date__range : ''})} 
        }>View Breakdown</span></React.Fragment>)
      },
      {
        title: 'Service Completed',
        dataIndex: 'service_completed',
        key: 'service_completed',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Complaints',
        dataIndex: 'complaints',
        key: 'complaints',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: () => {
          return <span><img width="16" src={smile_icon} alt="" className="emoji-icon"/> %</span>
        },
        dataIndex: 'happy',
        key: 'happy',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: () => {
          return <span><img width="16" src={neutral_icon} alt="" className="emoji-icon"/> %</span>
        },
        dataIndex: 'neutral',
        key: 'neutral',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: () => {
          return <span><img width="16" src={sad_icon} alt="" className="emoji-icon"/> %</span>
        },
        dataIndex: 'sad',
        key: 'sad',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      }
    ]
    return customerComplaintColumns
  }

  CustomerComplaintsReportDetails = ( self ) => {
    const customerComplaintDetailsColumns = [
      {
        title: 'Ticket Name',
        dataIndex: 'title',
        key: 'title',
        className: 'tname',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer_name',
        key: 'customer_name',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<React.Fragment><span className="type ellipse">{text}</span></React.Fragment>)
      },
      {
        title: 'Disposition',
        dataIndex: 'reason',
        key: 'reason',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="d-block"><span className={text === 'open' ? 'type ellipse complaint-status positive-status' : 'type ellipse complaint-status negative-status'}></span>{text.charAt(0).toUpperCase() + text.slice(1)}</span>)
      },
      {
        title: 'Ticket created',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      }
    ]
    return customerComplaintDetailsColumns
  }

  CommercialSalesReports = (self) => {
    const csr1Columns = [
      {
        title: 'Franchise',
        dataIndex: 'name',
        key: 'name',
        className: 'tname',
        render: (text, record) => (<React.Fragment><span className="type ellipse">{text}</span></React.Fragment>)
      },
      {
        title: '',
        dataIndex: '',
        key: 'view_breakdown',
        className: 'tname',
        render: (text, record) => (<React.Fragment><span className="type ellipse view-breakdown" onClick={()=>{self.setState({
          reportdetails: true,
          franchiseFilters: {
            ...self.state.franchiseFilters,
            id: record.id
          }
        })
        self.props.getCommercialSalesReports({franchise_id: record.id, ...self.state.franchiseFilters});
        self.props.getCommercialSalesReportsDetails({id: record.id});
        }}>View Breakdown</span></React.Fragment>)
      },
      {
        title: 'New_Rev',
        dataIndex: 'new_rev',
        key: 'new_rev',
        sorter: true,
        showSorterTooltip: false,
        className: 'tdate',
        render: (text,record) => (<span className="type ellipse">{'$' + formatToCurrency(text)}</span>)
      },
      {
        title: '#',
        dataIndex: 'revenue_count',
        key: 'revenue_count',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.revenue_count}</span>)
      },
      {
        title: 'Repairs',
        dataIndex: 'repairs',
        key: 'repairs',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{'$' + formatToCurrency(text)}</span>)
      },
      {
        title: '#',
        dataIndex: 'repair_count',
        key: 'repair_count',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.repair_count}</span>)
      }

    ]
    return csr1Columns;
  }

  CommercialSalesReportsDetail = (self) => {
    const csr1DetailColumns = [
      {
        title: 'Business Development Officer',
        dataIndex: 'business_development_officer',
        key: 'business_development_officer',
        className: 'tdate',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'New_Rev',
        dataIndex: 'new_rev',
        key: 'new_rev',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: '#',
        dataIndex: 'revenue_count',
        key: 'revenue_count',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) =>(<span className="type ellipse">{record.revenue_count}</span>)
      },
      { 
        title: 'Repairs',
        dataIndex: 'repairs',
        sorter: true,
        showSorterTooltip: false,
        key: 'repairs',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.repairs}</span>)
      },
      {
        title: '#',
        dataIndex: 'repairs_count',
        key: 'repairs_count',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.repair_count}</span>)
      }

    ]
    return csr1DetailColumns;
  }

  CustomerPriceIncreaseReport = ( self ) => {
    const PriceIncreaseReportColumns = [
      {
        title: 'Franchise Name',
        dataIndex: 'franchise',
        key: 'franchise',
        className: 'tprice-increase-report',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Service Order',
        dataIndex: 'service_number',
        key: 'service_number',
        className: 'tprice-increase-report',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer_name',
        key: 'customer_name',
        sorter: false,
        showSorterTooltip: false,
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Customer Type',
        dataIndex: 'customer_type',
        key: 'customer_type',
        sorter: false,
        showSorterTooltip: false,
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Joined Duration',
        dataIndex: 'joined',
        key: 'joined',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Joined Date',
        dataIndex: 'joined_date',
        key: 'joined_date',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{record.joined_date ? moment(record?.joined_date).format("MM/DD/YYYY") : '-'}</span>)
      },
      {
        title: 'First Service Date',
        dataIndex: 'first_service_date',
        key: 'first_service_date',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{record.first_service_date ? moment(record?.first_service_date).format("MM/DD/YYYY") : '-'}</span>)
      },
      {
        title: 'Last Service Date',
        dataIndex: 'last_service_date',
        key: 'last_service_date',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{record.last_service_date ? moment(record?.last_service_date).format("MM/DD/YYYY") : '-'}</span>)
      },
      {
        title: 'Last Price Increase Date',
        dataIndex: 'last_increase',
        key: 'last_increase',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{record.last_increase ? moment(record?.last_increase).format("MM/DD/YYYY") : '-'}</span>)
      },
      {
        title: 'Last Price Increase Effective Date',
        dataIndex: 'price_increase_effective_date',
        key: 'price_increase_effective_date',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{record.price_increase_effective_date ? moment(record?.price_increase_effective_date).format("MM/DD/YYYY") : '-'}</span>)
      },
      {
        title: 'Last Price Increase Amount $/%',
        dataIndex: 'last_increase_amount',
        key: 'last_increase_amount',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{record.last_increase_amount ? record.last_increase_amount : '-'}</span>)
      },
      {
        title: ' Price Increase Status',
        dataIndex: 'last_increase_status',
        key: 'last_increase_status',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{record.last_increase_status ? record.last_increase_status : '-'}</span>)
      },
      {
        title: 'Starting Service Order Base Price',
        dataIndex: 'starting_base_price',
        key: 'starting_base_price',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">${formatToCurrency(record.starting_base_price)}</span>)
      },
      {
        title: 'Current Service Order Base Price',
        dataIndex: 'prior_base_price',
        key: 'prior_base_price',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">${formatToCurrency(record.prior_base_price)}</span>)
      },
      {
        title: 'Current Service Order Total Price',
        dataIndex: 'current_total_price',
        key: 'current_total_price',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">${formatToCurrency(record.current_total_price)}</span>)
      },
      {
        title: 'Satisfaction Score',
        dataIndex: 'satisfaction',
        key: 'satisfaction',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{text ? text  + "%": ''}</span>)
      },
      {
        title: 'Last Complaints Date',
        dataIndex: 'last_complaint',
        key: 'last_complaint',
        className: 'tprice-increase-report',
        render: (text, record) => (<span className="type ellipse">{record.last_complaint ? moment(record?.last_complaint).format("MM/DD/YYYY") : '-'}</span>)
      }
    ]
    return PriceIncreaseReportColumns;
  }

  CustomerPriceIncreaseReportDetails = ( self ) => {
    const PriceIncreaseReportDetailsColumns = [
      {
        title: 'Franchise Name',
        dataIndex: 'franchise',
        key: 'franchise',
        className: 'tname',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Service Order',
        dataIndex: 'service_number',
        key: 'service_number',
        className: 'tname',
        render: (text,record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer_name',
        key: 'customer_name',
        sorter: false,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Customer Type',
        dataIndex: 'customer_name',
        key: 'customer_name',
        sorter: false,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Joined Duration',
        dataIndex: 'joined',
        key: 'joined',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record.joined?moment(record.joined).diff(moment(), 'days') :"-"}</span>)
      },
      {
        title: 'Joined Date',
        dataIndex: 'joined',
        key: 'joined',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'First Service Date',
        dataIndex: 'first_service_date',
        key: 'first_service_date',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Last Service Date',
        dataIndex: 'last_service_date',
        key: 'last_service_date',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Last Price Increase Date',
        dataIndex: 'last_increase_date',
        key: 'last_increase_date',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Last Price Increase Effective Date',
        dataIndex: 'last_increase_effective_date',
        key: 'last_increase_effective_date',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Last Price Increase Amount/percentage',
        dataIndex: 'last_increase',
        key: 'last_increase',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Starting Service Order Base Price',
        dataIndex: 'starting_base_price',
        key: 'starting_base_price',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Prior Service Order Base Price',
        dataIndex: 'prior_base_price',
        key: 'prior_base_price',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Current Service Order Total Price',
        dataIndex: 'current_total_price',
        key: 'current_total_price',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Satisfaction Score',
        dataIndex: 'satisfaction',
        key: 'satisfaction',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text ? text  + "%": ''}</span>)
      },
      {
        title: 'Last Complaints Date',
        dataIndex: 'last_complaint',
        key: 'last_complaint',
        className: 'tname',
        render: (text, record) => (<span className="type ellipse" title={text}>{text}</span>)
      }
    ]
    return PriceIncreaseReportDetailsColumns;
  }

  CancellationReport = ( self ) => {
    const CancellationReportColumns = [
      {
        title: 'Customer Name',
        dataIndex: 'first_name',
        key: 'first_name',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record?.first_name} {record?.last_name}</span>)
      },
      {
        title: 'Franchise',
        dataIndex: 'field_office__name',
        key: 'field_office__name',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record?.field_office?.name}</span>)
      },
      {
        title: 'Signup Date',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        showSorterTooltip: false,
        className: 'tdate',
        render: (text, record) => (<span className="type ellipse" >{moment(record?.created_at).format("DD/MM/YYYY")}</span>)
      },

      {
        title: 'Service Address',
        dataIndex: 'service_address',
        key: 'service_address',
        className:"taddress",
        render: (text, record) => (<span className="type">{record?.invoice_address?.address ?record?.invoice_address?.address :'-'}</span>)
      },
      {
        title: 'City',
        dataIndex: 'res_city',
        key: 'res_city',
        className:"taddress",
        render: (text, record) => (<span className="type">{record?.invoice_address?.city ?record?.invoice_address?.city :'-'}</span>)
      },
      {
        title: 'State',
        dataIndex: 'res_state',
        key: 'res_state',
        className:"taddress",
        render: (text, record) => (<span className="type">{record?.invoice_address?.state ?record?.invoice_address?.state:'-'}</span>)
      },
      {
        title: 'Zipcode',
        dataIndex: 'res_zip_code',
        key: 'res_zip_code',
        className:"taddress",
        render: (text, record) => (<span className="type">{record?.invoice_address?.zip_code ?record?.invoice_address?.zip_code :'-'}</span>)
      },

      // {
      //   title: 'Address',
      //   dataIndex: 'invoice_address__address',
      //   key: 'invoice_address__address',
      //   sorter: true,
      //   showSorterTooltip: false,
      //   className: 'taddress',
      //   render: (text, record) => (<span className="type ellipse">{record?.invoice_address?.formatted_address}</span>)
      // },
      {
        title: 'Channel Attribution',
        dataIndex: 'channel_attribution',
        key: 'channel_attribution',
        render: (text, record) => (<span className="type ellipse">{
          record?.channel_attribution && record?.channel_attribution?.name !== 'Unknown' ? record?.channel_attribution?.name : '-'
        }</span>)
      },
      {
        title: 'Reason for Cancellation',
        dataIndex: 'cancelation_reason',
        key: 'cancelation_reason',
        sortDirections: ['ascend', 'descend'],
        sorter: (a, b) => a.cancelation_reason.localeCompare(b.cancelation_reason),
        showSorterTooltip: false,
        render: (text, record) => (<span className="type ellipse">{record?.cancelation_reason ? record?.cancelation_reason : '-'}</span>)
      },
      {
        title: 'Cancellation Date',
        dataIndex: 'cancelation_date',
        key: 'cancelation_date',
        sorter: true,
        showSorterTooltip: false,
        className: 'tdate',
        render: (text, record) => (<span className="type ellipse">{record?.cancelation_date ? moment(record.cancelation_date).format("MM/DD/YYYY") : "-"}</span>)
      },
      {
        title: 'Frequency',
        dataIndex: 'frequency',
        key: 'frequency',
        render: (text, record) => (<span className="type ellipse">{
          record?.frequency?.length > 0 ? record.frequency.map(item => {return FREQUENCY_MAPPING[item]}).join(', ') : '-'
        }</span>)
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type">{text}</span>)
      },
    ]
    return CancellationReportColumns;
  }

  CancellationReportWithoutFranchise = ( self ) => {
    const CancellationReportColumns = [
      {
        title: 'Customer Name',
        dataIndex: 'first_name',
        key: 'first_name',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record?.first_name} {record?.last_name}</span>)
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Address',
        dataIndex: 'invoice_address__address',
        key: 'invoice_address__address',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record?.invoice_address?.formatted_address}</span>)
      },
      {
        title: 'Signup Date',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse" title={moment(record?.created_at).format("MM/DD/YYYY hh:mm: a")} >{moment(record?.created_at).format("MM/DD/YYYY hh:mm: a")}</span>)
      },
      {
        title: 'Reason for Cancellation',
        dataIndex: 'cancelation_reason',
        key: 'cancelation_reason',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record?.cancelation_reason ? record?.cancelation_reason : '-'}</span>)
      },
      {
        title: 'Date Cancelled',
        dataIndex: 'cancelation_date',
        key: 'cancelation_date',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{record?.cancelation_date}</span>)
      }
    ]
    return CancellationReportColumns;
  }

  CancellationReportDetails = ( self ) => {
    const CancellationReportDetailsColumns = [
      {
        title: 'Customer Name',
        dataIndex: 'first_name',
        key: 'first_name',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Franchise',
        dataIndex: 'field_office__name',
        key: 'field_office__name',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Address',
        dataIndex: 'invoice_address__address',
        key: 'invoice_address__address',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Signup Date',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Reason for Cancellation',
        dataIndex: 'cancelation_reason',
        key: 'cancelation_reason',
        sorter: true,
        showSorterTooltip: false,
        render: (text, record) => (<span className="type ellipse">{record?.cancelation_reason ? record?.cancelation_reason : '-'}</span>)
      },
      {
        title: 'Date Cancelled',
        dataIndex: 'cancelation_date',
        key: 'cancelation_date',
        sorter: true,
        showSorterTooltip: false,
        className: 'tname',
        render: (text, record) => (<span className="type ellipse">{text ? text + "%": ''}</span>)
      }
    ]
    return CancellationReportDetailsColumns;
  }

  RoyaltyReportDetails = ( self ) => {
    const RoyaltyReportDetailsColumns = [
      {
        title: 'Franchise',
        dataIndex: 'name',
        key: 'name',
        // defaultSortOrder: 'ascend',
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: (a, b) => a.name.localeCompare(b.name),
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Territory',
        dataIndex: 'territory',
        key: 'territory',
        // defaultSortOrder: 'ascend',
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: (a, b) => a.territory.localeCompare(b.territory),
        render: (text, record) => (
          <span 
            className="type ellipse" 
            style={record.is_main ? {fontWeight: "bold"} : text=== "unowned" ? {fontStyle: "italic", color: "lightgray"} : {}}
          >
            {text === "unowned" ? "Unowned Territory" : text[0].toUpperCase() + text.slice(1).toLowerCase()}
          </span>)
      },
      {
        title: 'Owner',
        dataIndex: 'owner',
        key: 'owner',
        // defaultSortOrder: 'ascend',
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: (a, b) => a.owner.localeCompare(b.owner),
        render: (text, record) => (<span className="type ellipse" style={record.is_main ? {fontWeight: "bold"} : {}}>
          {text}
        </span>)
      },
      {
        title: 'Territory Sales',
        dataIndex: 'territory_sales',
        key: 'territory_sales',
        render: (text, record) => (
          <span className="type ellipse">
            {!record.is_main ? `$${formatToCurrency(record.territory_sales)}` : '-'}
          </span>
        )
      },
      {
        title: 'Total Sales',
        dataIndex: 'total_sales',
        key: 'total_sales',
        render: (text, record) => (
          <span className="type ellipse"  style={record.is_main ? {fontWeight: "bold"} : {}}>
            {record.is_main ? `$${formatToCurrency(record.total_sales)}` : '-'}
          </span>
        )
      },
      {
        title: '',
        dataIndex: '',
        key: 'view_breakdown',
        className: 'text-link',
        render: (text, record) => 
        {
          return (!record.is_owned || record.territory !== 'Owned')? <a 
            onClick={() => self.props.history.push(`/reports/royalty-reports-viewbreakdown`, 
              {query:{record, start_date: self.state.filters.start_date, end_date:  self.state.filters.end_date}})} 
            style={{cursor: 'pointer', fontWeight: "bold"}}
          >
              View Breakdown
          </a> : null
        }
      },
      
    ]
    return RoyaltyReportDetailsColumns;
  }

  RoyaltyReportBreakDownDetails = ( self ) => {
    const RoyaltyReportBreakDownDetailsColumns = [
      {
        title: 'ZIP Code',
        dataIndex: 'zipcode',
        key: 'zipcode',
        // defaultSortOrder: 'ascend',
        // sortDirections: ['ascend', 'descend', 'ascend'],
        // sorter: (a, b) => a.name.localeCompare(b.name),
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Sales',
        dataIndex: 'total_sales_by_zipcode',
        key: 'total_sales_by_zipcode',
        render: (text, record) => (<span className="type ellipse">${formatToCurrency(text)}</span>)
      },
    ]
    return RoyaltyReportBreakDownDetailsColumns;
  }

  ResidentialLeadReportDetails = ( self ) => {
    const ResidentialLeadReportDetailsColumns = [
      {
        title: 'Lead Name',
        dataIndex: 'lead',
        key: 'lead',
        className: "tname",
        render: (text, record) => (<span className='type'>{`${record.first_name} ${record.last_name}`}</span>)
      },
      {
        title: 'Franchise',
        dataIndex: 'name',
        key: 'name',
        className: "tname",
        render: (text, record) => (<span className="type ellipse">{record?.field_office?.name ? record?.field_office?.name : ''}</span>)
      },
      {
        title: 'Lead Status',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => (<span className="type ellipse">{record.is_active ? 'Active' : 'Inactive'}</span>)
      },
      {
        title: 'Lead Creation Date',
        dataIndex: 'creation_date',
        key: 'creation_date',
        render: (text, record) => (<span className="type ellipse">{record.created_at ? moment(record?.created_at).format("L") : '-'}</span>)
      },
      // {
      //   title: 'Type',
      //   dataIndex: 'lead',
      //   key: 'lead',
      //   render: (text, record) => (<span className="type ellipse">Lead</span>)
      // },
      {
        title: 'Zip Code',
        dataIndex: 'zipcode',
        key: 'zipcode',
        render: (text, record) => (<span className="type ellipse">{record.zip_code}</span>)
      },
      {
        title: 'Lead Stage',
        dataIndex: 'lead_stage',
        key: 'lead_stage',
        render: (text, record) => (<span className="type ellipse">{convertFirstCharToUppercase(record.lead_stage)}</span>)
      },
      {
        title: 'Last Contacted Date',
        dataIndex: 'last_contacted_date',
        key: 'last_contacted_date',
        // className: "tdate",
        render: (text, record) => (<span className="type ellipse">{record.lead_status_logs.length > 0 ? moment(record.lead_status_logs[0].created_at).format("L") : ''}</span>)
      },
      {
        title: 'Outreach',
        dataIndex: 'outreach',
        key: 'outreach',
        render: (text, record) => (<span className="type ellipse">{
          convertFirstCharToUppercase( record?.outreach.replaceAll("_", ' '))
        }</span>)
      },
      {
        title: 'Channel Attribution',
        dataIndex: 'channel_attribution',
        key: 'channel_attribution',
        render: (text, record) => (<span className="type ellipse">{
          record?.channel_attribution && record?.channel_attribution?.name !== 'Unknown' ? record?.channel_attribution?.name : '-'
        }</span>)
      },
      {
        title: 'How Hear',
        dataIndex: 'attribute_question',
        key: 'attribute_question',
        render: (text, record) => (<span className="type">{
          aboutUsData.filter(item => record?.hear_about_us?.includes(item.value)).map(item2 => {return item2.name}).join(', ')
        }</span>)
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        render: (text, record) => (<span className="type">{record?.email?.includes('@doody.com') ? '' : record?.email}</span>)
      },      
    ]
    return ResidentialLeadReportDetailsColumns;
  }

  ResidentialSignupReportDetails = ( self ) => {
    const ResidentialSignupReportDetailsColumns = [
      {
        title: 'Customer Name',
        dataIndex: 'customer',
        key: 'customer',
        className: "tname",
        render: (text, record) => (<span className='type'>{`${record.first_name} ${record.last_name}`}</span>)
      },
      {
        title: 'Franchise',
        dataIndex: 'name',
        key: 'name',
        className: "tname",
        render: (text, record) => (<span className="type ellipse">{record?.field_office?.name ? record?.field_office?.name : ''}</span>)
      },
      {
        title: 'Customer Status',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => (<span className="type ellipse">{record.is_active ? 'Active' : 'Inactive'}</span>)
      },
      // {
      //   title: 'Type',
      //   dataIndex: 'lead',
      //   key: 'lead',
      //   render: (text, record) => (<span className="type ellipse">Customer</span>)
      // },
      {
        title: 'Joined Date',
        dataIndex: 'joined_date',
        key: 'joined_date',
        className: "tdate",
        render: (text, record) => (<span className="type ellipse">{record?.created_at.length > 0 ? moment(record?.created_at).format("L") : ''}</span>)
      },
      {
        title: 'Frequency',
        dataIndex: 'frequency',
        key: 'frequency',
        render: (text, record) => (<span className="type ellipse">{
          record?.frequency?.length > 0 ? record.frequency.map(item => FREQUENCY_MAPPING[item]).join(', ') : '-'
        }</span>)
      },
      {
        title: 'Last Service',
        dataIndex: 'last_service',
        key: 'last_service',
        className: "tdate",
        render: (text, record) => (<span className="type ellipse">{record?.last_service?.length > 0 ? record?.last_service : ''}</span>)
      },
      {
        title: 'Service Address',
        dataIndex: 'service_address',
        key: 'service_address',
        className:"taddress",
        render: (text, record) => (<span className="type">{record?.invoice_address?.address ?record?.invoice_address?.address :'-'}</span>)
      },
      {
        title: 'City',
        dataIndex: 'res_city',
        key: 'res_city',
        className:"taddress",
        render: (text, record) => (<span className="type">{record?.invoice_address?.city ?record?.invoice_address?.city :'-'}</span>)
      },
      {
        title: 'State',
        dataIndex: 'res_state',
        key: 'res_state',
        className:"taddress",
        render: (text, record) => (<span className="type">{record?.invoice_address?.state ?record?.invoice_address?.state:'-'}</span>)
      },
      {
        title: 'Zipcode',
        dataIndex: 'res_zip_code',
        key: 'res_zip_code',
        className:"taddress",
        render: (text, record) => (<span className="type">{record?.invoice_address?.zip_code ?record?.invoice_address?.zip_code :'-'}</span>)
      },
      {
        title: 'Channel Attribution',
        dataIndex: 'channel_attribution',
        key: 'channel_attribution',
        render: (text, record) => (<span className="type ellipse">{
            record?.channel_attribution && record?.channel_attribution?.name !== 'Unknown' ? record?.channel_attribution?.name : '-'
          }</span>)
      },
      // {
      //   title: 'Satisfaction score',
      //   dataIndex: 'satisfaction_score',
      //   key: 'satisfaction_score',
      //   render: (text, record) => (<span className="type ellipse">{record?.customer_satisfaction_score}%</span>)
      // },
      {
        title: 'How Hear',
        dataIndex: 'attribute_question',
        key: 'attribute_question',
        render: (text, record) => (<span className="type">{
           aboutUsData.filter(item => record?.hear_about_us?.includes(item.value)).map(item2 => {return item2.name}).join(', ')
        }</span>)
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        render: (text, record) => (<span className="type" style={{maxWidth: "75%"}}>{record?.email?.includes('@doody.com') ? '' : record?.email}</span>)
      },      
    ]
    return ResidentialSignupReportDetailsColumns;
  }

  CommercialProposalReportDetails = ( self ) => {
    const CommercialProposalReportDetailsColumns = [
      {
        title: 'Community Name',
        dataIndex: 'community_name',
        key: 'community_name',
        render: (text, record) => (<span className='type'>{`${record?.community_name ? convertFirstCharToUppercase(record?.community_name) : '-'}`}</span>)
      },
      {
        title: 'Community Manager',
        dataIndex: 'community_manager',
        key: 'community_manager',
        render: (text, record) => (<span className="type">
            {`${record?.first_name ? convertFirstCharToUppercase(record?.first_name) + ' ' + convertFirstCharToUppercase(record?.last_name) : '-'}`}
          </span>)
      },
      {
        title: 'Management Company',
        dataIndex: 'management_company',
        key: 'management_company',
        render: (text, record) => (<span className="type">{convertFirstCharToUppercase(record?.management_company)}</span>)
      },
      {
        title: 'Property Type',
        dataIndex: 'properties_in_community',
        key: 'properties_in_community',
        render: (text, record) => (<span className="type">{
          record?.properties_in_community?.map(item => {return PROPERTY_TYPE_MAPPING[item]}).join(', ')
        }</span>)
      },
      {
        title: 'Franchise',
        dataIndex: 'franchise',
        key: 'franchise',
        render: (text, record) => (<span className="type ellipse">{`${record.field_office.name}`}</span>)
      },
      {
        title: 'Proposal Creation Date',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text, record) => (<span className="type ellipse">{record.created_at ? moment(record?.created_at).format("L") : '-'}</span>)
      },
      {
        title: 'Services',
        dataIndex: 'interested_services',
        key: 'interested_services',
        render: (text, record) => (<span className="type">{
          record?.interested_services?.map(item => {return convertFirstCharToUppercase(item.replaceAll("_", " "))}).join(', ')
        }</span>)
      },
      {
        title: 'Products',
        dataIndex: 'interested_products',
        key: 'interested_products',
        render: (text, record) => (<span className="type">{
          record?.interested_products?.map(item => {return convertFirstCharToUppercase(item.replaceAll("_", " "))}).join(', ')
        }</span>)
      },
      {
        title: 'Service Street Address',
        dataIndex: 'service_address',
        key: 'service_address',
        className:"taddress",
        render: (text, record) => (<span className="type">{`${record?.address ? record?.address.address : '-'}`}</span>)
      },
      {
        title: 'Service City',
        dataIndex: 'service_city',
        key: 'service_city',
        render: (text, record) => (<span className="type">{`${record?.address ? record?.address.city : '-'}`}</span>)
      },
      {
        title: 'Service State',
        dataIndex: 'service_state',
        key: 'service_state',
        render: (text, record) => (<span className="type">{`${record?.address ? record?.address.state : '-'}`}</span>)
      },
      {
        title: 'Zip Code',
        dataIndex: 'zip_code',
        key: 'zip_code',
        render: (text, record) => (<span className="type">{`${record?.address ? record?.address.zip_code : '-'}`}</span>)
      },
      {
        title: 'Outreach',
        dataIndex: 'outreach',
        key: 'outreach',
        render: (text, record) => (<span className="type">{
          record?.outreach ? convertFirstCharToUppercase( record?.outreach.replaceAll("_", ' ')) :'-'
        }</span>)
      },
      {
        title: 'Channel Attribution',
        dataIndex: 'channel_attribution',
        key: 'channel_attribution',
        render: (text, record) => (<span className="type">{
          record?.channel_attribution && record?.channel_attribution?.name !== 'Unknown' ? record?.channel_attribution?.name : '-'
        }</span>)
      },
      {
        title: 'How Hear',
        dataIndex: 'attribute_question',
        key: 'attribute_question',
        render: (text, record) => (<span className="type">{
           aboutUsData.filter(item => record?.hear_about_us?.includes(item.value)).map(item2 => {return item2.name}).join(', ')
        }</span>)
      },
      {
        title: 'Email Addresss',
        dataIndex: 'email_address',
        key: 'email_address',
        class: "temail",
        render: (text, record) => (<span className="type">{text}</span>)
      },      
    ]
    return CommercialProposalReportDetailsColumns;
  }

  CommercialSignupReportDetails = ( self ) => {
    const getFirstItemOrDefault = (array) => {
      const hasItems = array !== undefined && array !== null && array.length > 0

      if (!hasItems) {
        return {}
      }

      return array[0]
    }
    
    const CommercialSignupReportDetailsColumns = [
      {
        title: 'Community Name',
        dataIndex: 'community_name',
        key: 'community_name',
        render: (text, record) => (<span className='type'>{`${record?.community_name ? convertFirstCharToUppercase(record?.community_name) : '-'}`}</span>)
      },
      {
        title: 'Community Manager',
        dataIndex: 'community_manager',
        key: 'community_manager',
        render: (text, record) => (<span className="type">
            {`${record?.first_name ? convertFirstCharToUppercase(record?.first_name) + ' ' + convertFirstCharToUppercase(record?.last_name) : '-'}`}
          </span>)
      },
      {
        title: 'Management Company',
        dataIndex: 'management_company',
        key: 'management_company',
        render: (text, record) => (<span className="type">{convertFirstCharToUppercase(record?.management_company)}</span>)
      },
      {
        title: 'Property Type',
        dataIndex: 'property_type',
        key: 'property_type',
        render: (text, record) => (<span className="type">{
          record?.property_type?.map(item => {return PROPERTY_TYPE_MAPPING[item]}).join(', ')
        }</span>)
      },
      {
        title: 'Franchise',
        dataIndex: 'franchise',
        key: 'franchise',
        render: (text, record) => (<span className="type">{`${record.field_office?.name ? record.field_office.name : '-'}`}</span>)
      },
      {
        title: 'Joined Date',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text, record) => (<span className="type">{record.created_at ? moment(record?.created_at).format("L") : '-'}</span>)
      },
      {
        title: 'Services',
        dataIndex: 'service_list',
        key: 'service_list',
        render: (text, record) => (<span className="type">{
          record?.service_list && record?.service_list?.length > 0 ?
            record?.service_list.map(item => {return convertFirstCharToUppercase(item[0].item.replaceAll("_", " "))}).join(', ')
            : '-'
        }</span>)
      },
      {
        title: 'Products',
        dataIndex: 'product_list',
        key: 'product_list',
        render: (text, record) => (<span className="type">{
          record?.product_list && record?.product_list?.length > 0 ?
            record?.product_list.map(item => {return (convertFirstCharToUppercase(item[0].item.replaceAll("_", " ")))}).join(', ')
            : '-'
        }</span>)
      },
      {
        title: 'Frequency',
        dataIndex: 'frequency',
        key: 'frequency',
        render: (text, record) => (<span className="type">{
          record?.frequency_list?.length > 0 ? record.frequency_list.map(item => {return FREQUENCY_MAPPING[item]}).join(', ') : '-'
        }</span>)
      },
      {
        title: 'Service Street Address',
        dataIndex: 'service_address',
        key: 'service_address',
        className:"taddress",
        render: (text, record) => (<span className="type ellipse">{`${getFirstItemOrDefault(record?.address).address || '-'}`}</span>)
      },
      {
        title: 'Service City',
        dataIndex: 'service_city',
        key: 'service_city',
        render: (text, record) => (<span className="type ellipse">{`${getFirstItemOrDefault(record?.address).city || '-'}`}</span>)
      },
      {
        title: 'Service State',
        dataIndex: 'service_state',
        key: 'service_state',
        render: (text, record) => (<span className="type ellipse">{`${getFirstItemOrDefault(record?.address).state || '-'}`}</span>)
      },
      {
        title: 'Zip Code',
        dataIndex: 'zip_code',
        key: 'zip_code',
        render: (text, record) => (<span className="type ellipse">{`${getFirstItemOrDefault(record?.address).zip_code || '-'}`}</span>)
      },
      {
        title: 'Outreach',
        dataIndex: 'outreach',
        key: 'outreach',
        render: (text, record) => (<span className="type">{
          record?.outreach ? convertFirstCharToUppercase( record?.outreach.replaceAll("_", ' ')) : '-'
        }</span>)
      },
      {
        title: 'Channel Attribution',
        dataIndex: 'channel_attribution',
        key: 'channel_attribution',
        render: (text, record) => (<span className="type">{
          record?.channel_attribution && record?.channel_attribution?.name !== 'Unknown' ? record?.channel_attribution?.name : '-'
        }</span>)
      },
      {
        title: 'How Hear',
        dataIndex: 'attribute_question',
        key: 'attribute_question',
        render: (text, record) => (<span className="type">{
           aboutUsData.filter(item => record?.hear_about_us?.includes(item.value)).map(item2 => {return item2.name}).join(', ')
        }</span>)
      },
      {
        title: 'Email Addresss',
        dataIndex: 'email',
        key: 'email',
        class: "temail",
        render: (text, record) => (<span className="type">{text}</span>)
      },      
    ]
    return CommercialSignupReportDetailsColumns;
  }
  
  CouponReportDetails = ( self ) => {
    const CouponReportDetailsColumns = [
      {
        title: 'Coupon Code',
        dataIndex: 'coupon_code',
        key: 'coupon_code',
        className: "tname",
        render: (text, record) => (<span className='type'>{`${record.coupon_code.join(',')}`}</span>)
      },
      {
        title: 'Coupon Type',
        dataIndex: 'coupon_type',
        key: 'coupon_type',
        className: "tname",
        render: (text, record) => (<span className="type ellipse">{record?.coupon_type ? formattedCouponList(record?.coupon_type) : ''}</span>)
      },
      {
        title: 'Service order#',
        dataIndex: 'service_order_number',
        key: 'service_order_number',
        className: "tname",
        render: (text, record) => (<span className="type ellipse">{record?.service_number ? record?.service_number.join(',') : ''}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer_name',
        key: 'customer_name',
        className: "tname",
        render: (text, record) => (<span className="type ellipse">{record?.first_name ? record?.first_name + ' ' + record?.last_name : ''}</span>)
      },
      {
        title: 'Franchise Name',
        dataIndex: 'franchise_name',
        key: 'franchise_name',
        className: "tname",
        render: (text, record) => (<span className="type ellipse">{record?.field_office ? record?.field_office.name : ''}</span>)
      },
      // {
      //   title: 'Invoiced value',
      //   dataIndex: 'invoiced_value',
      //   key: 'invoiced_value',
      //   className: "tname",
      //   render: (text, record) => (<span className="type ellipse">{record?.invoice_total ? record?.invoice_total.join(',') : ''}</span>)
      // },
      {
        title: 'Customer Sign Up Date',
        dataIndex: 'customer_sign_up_date',
        key: 'customer_sign_up_date',
        className: "tname",
        render: (text, record) => (<span className="type ellipse">{record?.created_at ? moment(record?.created_at).format("MM/DD/YYYY") : ''}</span>)
      },
    ]

    return CouponReportDetailsColumns;
  }
}

export default new DataTable();